module.exports = __webpack_public_path__ + "img/151.27884f8f.jpg";